import "./Opinion.module.css";
import Header from "@/reusable_sections/Header";
import MagicInEveryBite from "./sections/MagicInEveryBite";
import BeritaTerbaru from "./sections/BeritaTerbaru";
import KolaborasiPublik from "./sections/KolaborasiPublik";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function OpinionPage() {
  return <div>
      <Header />
      <MagicInEveryBite />
      <BeritaTerbaru />
      <KolaborasiPublik />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}